import React, { useEffect, useRef } from "react";
import universeVid from "./media/blue-universe-trim.mp4";

const Main = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // This forces the video to try and play again once the component loads
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay prevented by browser:", error);
      });
    }
  }, []);

  return (
    <video
      ref={videoRef}
      src={universeVid}
      autoPlay
      loop
      muted
      playsInline
      webkit-playsinline="true"
      preload="auto"
      className="ball-video"
    />
  );
};

export default Main;
